import "../scss/style.scss";
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import magnificPopup from 'magnific-popup';
import "./top";

/*------------------------------------------
	common
------------------------------------------*/
// nav child
$(function() {
	$('.js-nav-parent').on('click', function() {
		$(this).toggleClass('is-open');
		$('+ .js-nav-child', this).slideToggle();
		$('.js-nav-parent').not(this).removeClass('is-open')
		$('.js-nav-child').not($(this).next('.js-nav-child')).slideUp();
	});
	$('.js-nav a[href^="#"]').on('click',function() {
		$('.js-nav-parent').removeClass('is-open');
		$('.js-nav-child').slideUp();
	});
});


// SP menu
$(function() {
	$('.js-nav-btn').on('click',function() {
		$('.js-nav').fadeToggle();
		$(this).toggleClass('is-close');
	});
	$('.js-nav a[href^="#"]').on('click',function() {
		$('.js-nav').fadeOut();
		$('.js-nav-btn').removeClass('is-close');
	});
});


/*------------------------------------------
	home
------------------------------------------*/
// home header
$(function() {
	if ($('body').hasClass('is-home')) {
		var	element	= $('.js-header'),
				pos			= $('.js-home-mv').outerHeight();
		$(window).on('load scroll', function() {
			var scroll = $(window).scrollTop();
			if(scroll > pos) {
				element.addClass('is-scroll');
			} else {
				element.removeClass('is-scroll');
			}
		});
	}
});

document.addEventListener( 'DOMContentLoaded', function() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	// js-home-mv-slider
  if (document.getElementsByClassName('js-home-mv-slider').length) {

    setTimeout(() => {
      var jsHomeMvSlider_option = {
        type: 'fade',           // フェードアニメーション
        rewind: true,           // スライドをループする
        gap: 0,                 // スライド間のスペース
        pagination: false,      // ページネーションを非表示
        autoplay: true,         // 自動再生を有効
        interval: 3000,         // 自動再生の間隔（ミリ秒）
        pauseOnHover: false,    // ホバー時に一時停止しない
        speed: 600,             // アニメーション速度（ミリ秒）
        arrows: false,           // ナビゲーション矢印を表示
        drag: true,             // ドラッグを有効
        accessibility: true,
      };

      var jsHomeMvSlider = new Splide('.js-home-mv-slider', jsHomeMvSlider_option);

      // カスタム処理で autoplay を強制的にオンにする
      jsHomeMvSlider.on('mounted', () => {
        if (prefersReducedMotion) {
          jsHomeMvSlider.options.speed = 600;
          jsHomeMvSlider.Components.Autoplay.play();
      }
      });

      jsHomeMvSlider.mount();
    }, 3000);
  }


	// js-home-picture-slider
	if(document.getElementsByClassName('js-home-picture-slider').length) {
		var jsHomePictureSlider_option = {
      type: 'loop',
      rewind: true,
      gap: 0,
      pagination: false,
    }
    var jsHomePictureSlider = new Splide( '.js-home-picture-slider', jsHomePictureSlider_option );
    jsHomePictureSlider.mount();
	}

	// js-home-company-slider
	if(document.getElementsByClassName('js-home-company-slider').length) {
		var jsHomeCompanySlider_option = {
      type: 'slide',
      rewind: true,
      gap: 0,
      pagination: true,
    }
    var jsHomeCompanySlider = new Splide( '.js-home-company-slider', jsHomeCompanySlider_option );
    jsHomeCompanySlider.mount();
	}

	// js-home-news-slider
	if(document.getElementsByClassName('js-home-news-slider').length) {
		var jsHomeNewsSlider_option	=	{
					type					:	'loop',
					rewind				:	true,
					gap						:	'50px',
					speed					:	1000,
					fixedWidth		:	'260px',
					pagination		: false,
					autoplay			:	true,
					breakpoints		:	{
						767	: {
              focus					:	'center',
							gap						:	'30px',
						},
					},
				},
				jsHomeNewsSlider = new Splide( '.js-home-news-slider', jsHomeNewsSlider_option );
		jsHomeNewsSlider.mount();
	}

});

// menu
$(function() {
	$('.js-recruit-nav-btn').on('click',function() {
		$('.js-recruit-nav').fadeToggle();
		$(this).toggleClass('is-close');
	});
	$('.js-recruit-nav a[href^="#"], .js-recruit-nav-overlay').on('click',function() {
		$('.js-recruit-nav').fadeOut();
		$('.js-recruit-nav-btn').removeClass('is-close');
	});
});

// (sp) sub menu
$(function() {
  if(window.innerWidth < 768) {
		$('.js-recruit-nav-parent-sp').on('click', function() {
			$('+ .js-recruit-nav-child-sp', this).slideToggle();
			$(this).toggleClass('is-open');
			$('.js-recruit-nav-parent-sp').not(this).removeClass('is-open')
			$('.js-recruit-nav-child-sp').not($(this).next('.js-recruit-nav-child-sp')).slideUp();
		});
	}
});

// accordion
$(function() {
	$('.js-accordion-btn').append('<span class="btn"></span>')
	$('.js-accordion-btn').on('click', function() {
		$('+ .js-accordion-content', this).slideToggle();
		$(this).toggleClass('is-open');
	});
});

// recruit faq
$(function() {
	$('.js-recruit-faq-btn').on('click', function() {
		$('+ .js-recruit-faq-content', this).slideToggle();
		$(this).toggleClass('is-open');
	});
});

// .js-home-member-slider
document.addEventListener( 'DOMContentLoaded', function() {
	if(document.getElementsByClassName('js-home-member-slider').length) {
		var jsHomeMemberSlider_option	=	{
      type					:	'loop',
      autoplay			:	true,
      gap					  :	0,
      speed					:	1000,
      interval			:	3000,
      pagination		: false,
      fixedWidth    : '364px',
      updateOnMove  : true, // is-activeクラスを移動前に更新する
      rewind        : false,
      focus					:	'center',
      breakpoints		:	{
        767	: {
          fixedWidth		:	'320px',
          gap : 10,
        },
      },
    },
    jsHomeMemberSlider = new Splide( '.js-home-member-slider', jsHomeMemberSlider_option );
		jsHomeMemberSlider.mount();
	}

  if(document.getElementsByClassName('js-recruit-interview-slider').length) {
		var jsHomeMemberSlider_option	=	{
      type					:	'loop',
      autoplay			:	true,
      gap					  :	32,
      speed					:	1000,
      interval			:	3000,
      pagination		: false,
      fixedWidth    : '309px',
      updateOnMove  : true, // is-activeクラスを移動前に更新する
      rewind        : false,
      focus					:	'center',
      breakpoints		:	{
        767	: {
          fixedWidth		:	'272px',
          gap : 28,
        },
      },
    },
    jsHomeMemberSlider = new Splide( '.js-recruit-interview-slider', jsHomeMemberSlider_option );
		jsHomeMemberSlider.mount();
	}
});

// js-matchheight
$(function(){
  if ($('.js-matchheight').length) {
    $('.js-matchheight').matchHeight();
  }
});

// popup
$(document).ready(function() {
  $('.js-recruitTour-list__popup').magnificPopup({
    type: 'inline',
    closeBtnInside: true,
    closeMarkup: '<button class="mfp-close"></button>',
  });
});
